import React, { FC, memo } from 'react';
import { DivWrapper } from './styles';
import { TProductDescription } from '../../../commonTypes/basic';
import {
  DivImage,
  DivTextWrapper,
  DivTitle,
  DivDetails,
  SpanFieldName,
  DivCircle,
  SpanFieldValue,
  SpanRemark
} from './styles';

type TProps = {
  data: TProductDescription;
  className?: string;
};

const FnProductDescription: FC<TProps> = ({
  data: { name, imageUrl, color, size, sku, remark },
  className = ''
}) => {
  const thumbnail = (imageFileUrl: string) => {
    if (imageFileUrl) {
      return <DivImage style={{ backgroundImage: `url("${imageFileUrl}")` }} />;
    } else {
      return <DivImage style={{ backgroundImage: 'url("/assets/icons/file-image-light.svg")' }} />;
    }
  };

  const circle = (color: string) => {
    if (color) {
      return <DivCircle style={{ backgroundColor: color }} />;
    } else {
      return <DivCircle />;
    }
  };

  return (
    <DivWrapper className={className}>
      {thumbnail(imageUrl)}
      <DivTextWrapper>
        <DivTitle>{name}</DivTitle>
        <DivDetails>
          <SpanFieldName>Color:</SpanFieldName>
          {circle(color)}
          <SpanFieldValue>{color}</SpanFieldValue>
          <SpanFieldName>Size:</SpanFieldName>
          <SpanFieldValue>{size}</SpanFieldValue>
          {sku && <SpanFieldName>SKU #</SpanFieldName>}
          {sku && <SpanFieldValue>{sku}</SpanFieldValue>}
          {remark && <SpanRemark>{remark}</SpanRemark>}
        </DivDetails>
      </DivTextWrapper>
    </DivWrapper>
  );
};

export default memo(FnProductDescription);
